// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/RouteBuilder.module.css */


.RouteBuilder_page__Pb99R {
  display: flex;
  flex-direction: column;
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background-color: #f5f5f5;
  overflow: hidden; /* прокрутка только в content */
}

/* Зона, которая скроллится */
.RouteBuilder_content__Lddhf {
  flex: 1 1 auto;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.RouteBuilder_createSection__kYakz {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

@media (min-width: 600px) {
  .RouteBuilder_createSection__kYakz {
    flex-direction: row;
    align-items: center;
  }
}

.RouteBuilder_prefixInput__8mZv7 {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 60px;
}

.RouteBuilder_createBtn__gXQvi {
  padding: 8px 16px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.RouteBuilder_createBtn__gXQvi:disabled {
  background-color: #99caff;
  cursor: default;
}

.RouteBuilder_error__fCmMr {
  color: #d9534f;
  font-size: 0.9em;
}

.RouteBuilder_listSection__hnqyS {
  margin-bottom: 24px;
}

.RouteBuilder_listSection__hnqyS h2 {
  margin-bottom: 12px;
  font-size: 1.2em;
}

.RouteBuilder_filterRow__JeSN7 {
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
}

.RouteBuilder_filterRow__JeSN7 input[type="date"] {
  flex: 1 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.RouteBuilder_loadBtn__KzmCS {
  padding: 8px 16px;
  background-color: #28a745;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.RouteBuilder_loadBtn__KzmCS:disabled {
  background-color: #a6d8a8;
  cursor: default;
}

.RouteBuilder_list__WgdDj {
  list-style: none;
  padding: 0;
  margin: 0;
}

.RouteBuilder_item__yMN0Y {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.RouteBuilder_item__yMN0Y:hover {
  background-color: #f0f8ff;
}

.RouteBuilder_number__e6u9S {
  font-weight: bold;
}

.RouteBuilder_date__7C8Vt,
.RouteBuilder_status__CwoII {
  font-size: 0.9em;
  color: #555;
}

.RouteBuilder_empty__7Q6Py {
  text-align: center;
  color: #777;
  padding: 16px 0;
}


/* ========== Стили модалки ========== */

/* Оверлей */
.RouteBuilder_modalOverlay__XNHir {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  overflow: hidden;
}

/* Контейнер модалки */


`, "",{"version":3,"sources":["webpack://./src/modules/Admin/RouteBuilder/RouteBuilder.module.css"],"names":[],"mappings":"AAAA,sCAAsC;;;AAGtC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uGAAuG;EACvG,yBAAyB;EACzB,gBAAgB,EAAE,+BAA+B;AACnD;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;;AAGA,wCAAwC;;AAExC,YAAY;AACZ;EACE,eAAe;EACf,QAAQ;EACR,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA,sBAAsB","sourcesContent":["/* src/pages/RouteBuilder.module.css */\r\n\r\n\r\n.page {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\r\n  background-color: #f5f5f5;\r\n  overflow: hidden; /* прокрутка только в content */\r\n}\r\n\r\n/* Зона, которая скроллится */\r\n.content {\r\n  flex: 1 1 auto;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 24px;\r\n}\r\n\r\n.createSection {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n@media (min-width: 600px) {\r\n  .createSection {\r\n    flex-direction: row;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n.prefixInput {\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  width: 60px;\r\n}\r\n\r\n.createBtn {\r\n  padding: 8px 16px;\r\n  background-color: #007bff;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.createBtn:disabled {\r\n  background-color: #99caff;\r\n  cursor: default;\r\n}\r\n\r\n.error {\r\n  color: #d9534f;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.listSection {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.listSection h2 {\r\n  margin-bottom: 12px;\r\n  font-size: 1.2em;\r\n}\r\n\r\n.filterRow {\r\n  display: flex;\r\n  gap: 8px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.filterRow input[type=\"date\"] {\r\n  flex: 1;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.loadBtn {\r\n  padding: 8px 16px;\r\n  background-color: #28a745;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.loadBtn:disabled {\r\n  background-color: #a6d8a8;\r\n  cursor: default;\r\n}\r\n\r\n.list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  padding: 12px;\r\n  margin-bottom: 8px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.item:hover {\r\n  background-color: #f0f8ff;\r\n}\r\n\r\n.number {\r\n  font-weight: bold;\r\n}\r\n\r\n.date,\r\n.status {\r\n  font-size: 0.9em;\r\n  color: #555;\r\n}\r\n\r\n.empty {\r\n  text-align: center;\r\n  color: #777;\r\n  padding: 16px 0;\r\n}\r\n\r\n\r\n/* ========== Стили модалки ========== */\r\n\r\n/* Оверлей */\r\n.modalOverlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background-color: rgba(0, 0, 0, 0.4);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Контейнер модалки */\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `RouteBuilder_page__Pb99R`,
	"content": `RouteBuilder_content__Lddhf`,
	"createSection": `RouteBuilder_createSection__kYakz`,
	"prefixInput": `RouteBuilder_prefixInput__8mZv7`,
	"createBtn": `RouteBuilder_createBtn__gXQvi`,
	"error": `RouteBuilder_error__fCmMr`,
	"listSection": `RouteBuilder_listSection__hnqyS`,
	"filterRow": `RouteBuilder_filterRow__JeSN7`,
	"loadBtn": `RouteBuilder_loadBtn__KzmCS`,
	"list": `RouteBuilder_list__WgdDj`,
	"item": `RouteBuilder_item__yMN0Y`,
	"number": `RouteBuilder_number__e6u9S`,
	"date": `RouteBuilder_date__7C8Vt`,
	"status": `RouteBuilder_status__CwoII`,
	"empty": `RouteBuilder_empty__7Q6Py`,
	"modalOverlay": `RouteBuilder_modalOverlay__XNHir`
};
export default ___CSS_LOADER_EXPORT___;
